module.exports = __webpack_public_path__ + "img/vi.17a1fd81.png";